<template>
    <v-flex class="training-certification" v-if="isSectionVisible() || isCurrentUser">
        <v-flex tag="h2">{{memberProfileConstants.TRAINING_CERTIFICATION.TRAINING}}<i v-if="isCurrentUser" class="fas fa-pencil-alt ml-2" @click="openTrainingAndCertificationDialog()" data-qe-id="training_dialog_edit"> </i></v-flex>
        <v-flex v-if="!isSectionVisible() && isCurrentUser"> {{memberProfileConstants.DEFAULT_EDIT_TEXT.TRAINING_CERTIFICATION}} </v-flex>
        <status-overlay :action="loadGetTrainingAndCertificationsAction" content-height="240px"></status-overlay>
        <v-flex class="training__row" v-if="trainingAndCertifications.Course">
            <v-flex tag="strong">{{memberProfileConstants.TRAINING_CERTIFICATION.COURSES_TAKEN}}</v-flex>
            <v-flex mb-3 v-for="(course, index) in trainingAndCertifications.Course" :key="index">
                <v-flex tag="span" v-if="course.url">
                    <a class="website-link" :href="normalizeUrl(course.url)" target="_blank">{{course.name}}</a>
                </v-flex>
                <v-flex tag="span" v-if="!course.url">{{course.name}}</v-flex>
                <v-flex tag="small">{{course.startDate}} {{endDate(course)}}</v-flex>
            </v-flex>
        </v-flex>
        <v-flex class="training__row" v-if="trainingAndCertifications.Certification">
            <v-flex tag="strong">{{memberProfileConstants.TRAINING_CERTIFICATION.CERTIFICATIONS}}</v-flex>
            <v-flex mb-3 v-for="(certificate, index) in trainingAndCertifications.Certification" :key="index">
                <v-flex tag="span" v-if="certificate.url">
                    <a class="website-link" :data-qe-id="`certificate_${index}_link`" :href="normalizeUrl(certificate.url)" target="_blank">{{certificate.name}}</a>
                </v-flex>
                <v-flex tag="span" v-if="!certificate.url">{{certificate.name}}</v-flex>
                <v-flex tag="small">{{certificate.startDate}} {{endDate(certificate)}}</v-flex>
            </v-flex>
        </v-flex>
        <v-dialog scrollable v-model="isCertificationCoursesDialog" content-class="medium">
            <v-card class="myprofile-popup">
                <v-card-title primary-title>
                    {{memberProfileConstants.TRAINING_CERTIFICATION.EDIT_TRAINING_CERTIFICATION}}
                    <i class="fas fa-times" data-qe-id="close_dialog_btn" @click="isCertificationCoursesDialog = false"></i>
                </v-card-title>
                <v-card-text class="inner-scrollbar">
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.TRAINING_CERTIFICATION.COURSES_TAKEN}}
                            <span class="add-edit-btn" data-qe-id="open_course_dialog" @click="openCourseDialog()">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex mb-3 v-for="(course,index) in trainingAndCertifications.Course" :key="index">
                            <v-flex tag="strong">{{course.name}} <i class="fas fa-pencil-alt" :data-qe-id="`edit_course_${index}`" @click="editCourse(course)"></i></v-flex>
                            <v-flex tag="small">{{course.startDate}} {{endDate(course)}}</v-flex>
                        </v-flex>
                    </v-flex>
                    <v-flex class="details-view">
                        <v-flex tag="h6">{{memberProfileConstants.TRAINING_CERTIFICATION.CERTIFICATIONS}} 
                            <span class="add-edit-btn" data-qe-id="open_certification_dialog" @click="openCertificationDialog()">
                                <i class="fas fa-pencil-alt"></i>
                                <i class="fas fa-plus-circle"></i>
                            </span>
                        </v-flex>
                        <v-flex mb-3 v-for="(certificate, index) in trainingAndCertifications.Certification" :key="index">
                            <v-flex tag="strong">{{certificate.name}} <i class="fas fa-pencil-alt" :data-qe-id="`edit_certification_${index}`" @click="editCertification(certificate)"></i></v-flex>
                            <v-flex tag="small">{{certificate.startDate}} {{endDate(certificate)}}</v-flex>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-btn flat class="primary_btn" data-qe-id="close_dialog_btn" @click="isCertificationCoursesDialog = false">
                            {{appCommonConstants.CLOSE}}
                        </v-btn>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog scrollable v-model="certificationsDialog" content-class="medium" >
            <CertificationsDialog v-if="certificationsDialog"
                :certification="certification"
                @click="handleDialog"
                :certifications="certifications"
                :isCertificationEditDialog="isCertificationEditDialog"
                :memberId="memberId" />
        </v-dialog>
        <v-dialog scrollable v-model="coursesDialog" content-class="medium">
            <CourseDialog v-if="coursesDialog"
                @click="handleDialog"
                :courses="courses"
                :isCourseEditDialog="isCourseEditDialog"
                :course="course"
                :memberId="memberId" />
        </v-dialog>
    </v-flex>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { storeAction } from "../../store/storeActions.constant";
import { storeGetters } from "../../store/storeGetters.constant";
import { memberProfileConstants } from "./memberProfile.constants.js";
import { appCommonConstants } from "../appCommon.constants.js";
import CertificationsDialog from "./EditDialogues/CertificationsDialog";
import CourseDialog from "./EditDialogues/CourseDialog";
import { normalizeUrl } from '@/common/utils/utils';
import StatusOverlay from '../StatusOverlay/StatusOverlay';
import Vue from 'vue';

export default {
    name: "TrainingCertification",
    data: () => ({
        appCommonConstants,
        memberProfileConstants,
        coursesDialog: false,
        certificationsDialog: false,
        isCertificationEditDialog: false,
        isCourseEditDialog: false,
        isCertificationCoursesDialog: false,
        normalizeUrl,
        courses: [],
        certifications: [],
        course: {
            id: null,
            name: null,
            type: null,
            endDate: null,
            startDate: null,
            url: null,
            location: null,
            topic: null,
            description: null,
            industryCategory: null,
            subIndustryCategory: null,
            isEdit: false,
            isDelete: true,
            isAdd: false,
            isSuccess: false,
            isEditDialog: false,
            startMonth: '',
            startYear: '',
            endMonth: '',
            endYear: '',
            isSearch: false,
            isSave: false,
            subIndustry: [],
        },
        certification: {
            id: null,
            name: null,
            type: null,
            endDate: null,
            startDate: '',
            url: null,
            location: null,
            topic: null,
            description: null,
            industryCategory: null,
            subIndustryCategory: null,
            isEdit: false,
            isDelete: true,
            isAdd: false,
            isSuccess: false,
            isEditDialog: false,
            startMonth: '',
            startYear: '',
            isSearch: false,
            isSave: false,
            subIndustry: [],
        },
    }),
    components: {
        CertificationsDialog,
        CourseDialog,
        StatusOverlay,
    },
    props: {
        memberId: {
            type: String,
            required: true,
        },
    },
    created() {
        this.getTrainingAndCertifications(this.memberId);
    },
    methods: {
        ...mapActions({
            getTrainingAndCertifications: `memberProfile/${storeAction.getTrainingAndCertifications}`,
            searchCourseAndCertificate: `memberProfile/${storeAction.searchCourseAndCertificate}`,
        }),
        openTrainingAndCertificationDialog() {
            this.isCertificationCoursesDialog = true;
        },
        handleDialog(variable) { 
            this.certificationsDialog = variable;
            this.coursesDialog = variable;
        },
        endDate(data) {
            return data.endDate && data.startDate ?
                `- ${data.endDate}` :
                "";
        },
        isSectionVisible() {
            return this.trainingAndCertifications.Course || this.trainingAndCertifications.Certification;
        },
        openCertificationDialog() {
            this.isCertificationEditDialog = false;
            this.certificationsDialog = true;
            this.certifications = [];
            this.certifications.push(Vue.util.extend({}, this.certification));
        },
        openCourseDialog() {
            this.isCourseEditDialog = false;
            this.coursesDialog = true;
            this.courses = [];
            this.courses.push(Vue.util.extend({}, this.course));
        },
        editCertification(certification) {
            this.certifications = [{
                id: certification.id,
                name: certification.name,
                type: certification.type,
                endDate: certification.endDate,
                startDate: certification.startDate,
                url: certification.url,
                location: certification.location,
                topic: certification.topic,
                description: certification.description,
                industryCategory: certification.industryCategory,
                subIndustryCategory: certification.subIndustryCategory,
                isEditDialog: true,
                startMonth: certification.startDate ? certification.startDate.split(' ')[0] : null,
                startYear: certification.startDate ? Number(certification.startDate.split(' ')[1]) : null,
                isSave: true,
                subIndustry: this.industory[certification.industryCategory],
            }];
            this.certificationsDialog = true;
            this.isCertificationEditDialog = true;
        },
        editCourse(course) {
            this.courses = [{
                id: course.id,
                name: course.name,
                type: course.type,
                endDate: course.endDate,
                startDate: course.startDate,
                url: course.url,
                location: course.location,
                topic: course.topic,
                description: course.description,
                industryCategory: course.industryCategory,
                subIndustryCategory: course.subIndustryCategory,
                isEditDialog: true,
                startMonth: course.startDate ? course.startDate.split(' ')[0] : null,
                startYear: course.startDate ? Number(course.startDate.split(' ')[1]) : null,
                endMonth: course.endDate ? course.endDate.split(' ')[0] : null,
                endYear: course.endDate ? Number(course.endDate.split(' ')[1]) : null,
                isSave: true,
                subIndustry: this.industory[course.industryCategory],
            }];
            this.coursesDialog = true;
            this.isCourseEditDialog = true;
        },
    },
    computed: {
        ...mapGetters({
            trainingAndCertifications: `memberProfile/${storeGetters.trainingAndCertifications}`,
            currentUserId: `memberProfile/${storeGetters.currentUserId}`,
            industory: `memberProfile/${storeGetters.externalConnectionIndustry}`,
            chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
        }),
        ...mapState("actionState", ["actions"]),
        isCurrentUser() {
            return this.memberId === this.currentUserId || this.chapterAdminEditable;
        },
        loadGetTrainingAndCertificationsAction() {
            return this.actions[storeAction.getTrainingAndCertifications];
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../../common/styles/_colors.scss";

.training {
    border-bottom: 1px solid $ypo-open-blue-gray;
    margin-bottom: 20px;
    position: relative;
    &__row {
        margin-bottom: 15px;

        strong {
            display: block;
            margin-bottom: 5px;
        }

        span {
            display: block;
        }

        .website-link {
            text-decoration: none;
            color: $black;
        }
    }
}

.training-certification{
    padding: 0 20px;
    position: relative;
    
    .overlay {
        top: 35px;
    }
}

h2 {
    color: $ypo_blue;
    font-family: "Raleway", sans-serif;
    font-size: 22px;
    font-weight: 500;
    margin-bottom: 20px;
    line-height: 26px;
}
@media (max-width: 1199px) {
    .training-certification {
        padding: 0;
    }
}
</style>
